import { RouterProvider } from 'react-router-dom'
import { ErrorBoundary } from '@/components/common/ErrorBoundary'
import { AuthProvider } from '@/context/AuthContext'
import { ThemeProvider } from '@/context/ThemeContext'
import { CartProvider } from '@/context/CartContext'
import { TooltipProvider } from '@/components/ui/tooltip'
import { router } from '@/router'
import { ConsentProvider, CookieConsentManager } from '@/features/consent'

function App() {
  return (
    <ErrorBoundary>
      <ConsentProvider>
        <ThemeProvider>
          <AuthProvider>
            <CartProvider>
              <TooltipProvider>
                <RouterProvider router={router} />
                <CookieConsentManager />
              </TooltipProvider>
            </CartProvider>
          </AuthProvider>
        </ThemeProvider>
      </ConsentProvider>
    </ErrorBoundary>
  )
}

export default App
